@import "../../../global/gx-ide-mixins.scss";
@import "../../../global/gx-ide-common.scss";
@include box-sizing;

:host {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  font-size: var(--item__font-size);
}
.list {
  // reset defaults
  border: none;
  margin: 0;
  padding: 0;
  outline: 0;
  // /reset defaults

  // base component styles
  color: var(--color-text-neutral-default);
  background-color: var(
    --elevation-background-color,
    var(--color-accent-surface-elevation-1)
  );
  border-radius: 4px;
  font-size: var(--font-size-body-m);
  font-weight: var(--font-style-regular);
  // /base component styles

  display: grid;
  max-height: 100%;
  overflow-y: auto;
  gap: var(--spacing-gap-xs);
  padding: var(--spacing-padding-m);
}
/*no border*/
:host([no-list-border]) {
  .list {
    border: none;
  }
}
